import { FC } from 'react';
import { getRankTitle } from 'src/common/helpers';
import { RankTitleProps } from './rank-title.types';
import { StyledId, StyledNickname } from './rank-title.styles';
export const RankTitle: FC<RankTitleProps> = ({
  level
}) => {
  const title = getRankTitle(level);
  const isLongText = title.includes('][');
  const isWizard = level === 10;
  if (!title) return null;
  if (isLongText) {
    const id = `${title.split('][')?.at(0) ?? ''}]`;
    const nickName = `[${title.split('][')?.at(1) ?? ''}`;
    return <>
        <StyledId wizard={isWizard}>{id}</StyledId>
        <StyledNickname wizard={isWizard}>{nickName}</StyledNickname>
      </>;
  }
  if (!title.includes('0x')) return <StyledNickname>{title}</StyledNickname>;
  return <StyledId data-sentry-element="StyledId" data-sentry-component="RankTitle" data-sentry-source-file="rank-title.tsx">{title}</StyledId>;
};